import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { CameraItemDto } from "~/api/GeneratedApi";
import { FormComponentProps } from "~/components/ListDialog";
import { DialogAction } from "~/types/dialogAction";
import { useCameras } from "../hooks/useCameras";
import { CameraForm, CameraFormInputs } from "./CameraForm";
import { ListPageView } from "./ListPageView";

type RouterProps = {
  action: DialogAction;
  id: string;
};
export const CameraViewPage = (): JSX.Element => {
  const { getCameraById, addMutation, editMutation } = useCameras();

  const { goBack } = useHistory();
  const { id: cameraId, ...props } = useParams<RouterProps>();

  const handleItemGet = React.useCallback(
    (id: number) => {
      const camera = getCameraById(id);

      return camera;
    },
    [getCameraById],
  );

  const handleEdit = React.useCallback(
    (formData: CameraFormInputs, editId: number) => {
      return editMutation.mutateAsync({
        id: editId,
        dto: {
          ...formData,
          aisModemId: formData.aisModem?.deviceId,
        },
      });
    },
    [editMutation],
  );

  const handleAdd = React.useCallback(
    (formData: CameraFormInputs) => {
      return addMutation.mutateAsync({
        ...formData,
        aisModemDeviceId: formData.aisModem?.deviceId,
      });
    },
    [addMutation],
  );

  const renderForm = React.useCallback(
    ({
      defaultValues,
      formId,
      onSubmit,
      readOnly,
    }: FormComponentProps<CameraItemDto, CameraFormInputs>) => {
      return (
        <CameraForm
          defaultValues={defaultValues}
          formId={formId}
          onSubmit={onSubmit}
          readOnly={readOnly}
        />
      );
    },
    [],
  );

  return (
    <ListPageView<CameraItemDto, CameraFormInputs, number>
      getItemById={handleItemGet}
      editItem={handleEdit}
      addItem={handleAdd}
      onClose={goBack}
      formId="camera-form"
      renderFormComponent={renderForm}
      id={Number(cameraId)}
      {...props}
    />
  );
};
